module.exports = __webpack_public_path__ + "static/media/home1.ae05d8f0.jpg";